import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, ViewChild, Output, NgModule } from '@angular/core';
import * as i2 from '@ngrx/store';
import { select } from '@ngrx/store';
import { DEPENDENT_VISAS } from 'app-models';
import * as i8 from 'place-holder-library';
import { PlaceHolderDirective, PlaceHolderLibraryModule } from 'place-holder-library';
import { MailingAddressLibraryComponent, MailingAddressLibraryModule } from 'mailing-address-library';
import { FeeCalculationLibraryComponent, FeeCalculationLibraryModule } from 'fee-calculation-library';
import { Subject } from 'rxjs/internal/Subject';
import { getStepDetails, updateStepStatus, updateStepStatusToInitialState } from 'visa-store';
import { first } from 'rxjs/internal/operators/first';
import * as i3 from 'dirty-check-store';
import { MarkCleanFormAction } from 'dirty-check-store';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { ConsulateAddressLibraryComponent, ConsulateAddressLibraryModule } from 'consulate-address-library';
import { PortOfEntryLibraryComponent, PortOfEntryLibraryModule } from 'port-of-entry-library';
import { DependentFeeCalculationLibraryComponent, DependentFeeCalculationLibraryModule } from 'dependent-fee-calculation-library';
import { CardInformationComponent } from 'card-information';
import * as i1 from 'ngx-toastr';
import * as i4 from 'step-status-update-payload-service';
import * as i5 from '@angular/common';
import * as i6 from 'assigning-task-library';
import { AssigningTaskLibraryModule } from 'assigning-task-library';
import * as i7 from 'last-update-library';
import { LastUpdateLibraryModule } from 'last-update-library';
import * as i9 from 'step-status-update-component-library';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import * as i10 from 'maximize-dialog-library';
import { MaximizeDialogLibraryModule } from 'maximize-dialog-library';
import * as i11 from 'primeng/divider';
import { PrimengLibraryModule } from 'primeng-library';
import { GenerateFormsLibraryModule } from 'generate-forms-library';

class UscisContentLibraryService {
    constructor() { }
}
UscisContentLibraryService.ɵfac = function UscisContentLibraryService_Factory(t) { return new (t || UscisContentLibraryService)(); };
UscisContentLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: UscisContentLibraryService, factory: UscisContentLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UscisContentLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const _c0 = function (a0) { return { "layoutCode": a0 }; };
function UscisContentLibraryComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelementStart(1, "div", 19);
    i0.ɵɵelementStart(2, "div", 20);
    i0.ɵɵelementStart(3, "h2");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "p");
    i0.ɵɵtext(6, "Enter the mailing address & generate forms ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 21);
    i0.ɵɵelementStart(8, "ul");
    i0.ɵɵelementStart(9, "li", 22);
    i0.ɵɵelement(10, "lib-step-status-update-component-library", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "li", 24);
    i0.ɵɵelement(12, "lib-maximize-dialog-library", 25);
    i0.ɵɵelementStart(13, "i", 26);
    i0.ɵɵlistener("click", function UscisContentLibraryComponent_div_1_Template_i_click_13_listener() { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.handleClose(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", (ctx_r0.inputData == null ? null : ctx_r0.inputData.stepName) ? ctx_r0.inputData == null ? null : ctx_r0.inputData.stepName : "USCIS Content", " ");
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("visaType", ctx_r0.inputData.caseType != "I130" ? ctx_r0.inputData.visatype : ctx_r0.inputData.caseType)("stepDetails", ctx_r0.stepDetails)("isViewMode", ctx_r0.inputData["isViewMode"])("isCaseRequest", ctx_r0.inputData["isCaseRequest"]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("configData", i0.ɵɵpureFunction1(6, _c0, ctx_r0.inputData == null ? null : ctx_r0.inputData.layoutCode));
} }
function UscisContentLibraryComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵelementStart(1, "div", 19);
    i0.ɵɵelementStart(2, "div", 28);
    i0.ɵɵelementStart(3, "h2");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "p", 29);
    i0.ɵɵtext(6, "Enter the mailing address & generate forms ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 21);
    i0.ɵɵelementStart(8, "ul");
    i0.ɵɵelementStart(9, "li", 22);
    i0.ɵɵelement(10, "lib-step-status-update-component-library", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "li", 24);
    i0.ɵɵelement(12, "lib-maximize-dialog-library", 25);
    i0.ɵɵelementStart(13, "i", 26);
    i0.ɵɵlistener("click", function UscisContentLibraryComponent_div_2_Template_i_click_13_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.handleClose(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", (ctx_r1.inputData == null ? null : ctx_r1.inputData.stepName) ? ctx_r1.inputData == null ? null : ctx_r1.inputData.stepName : "USCIS Content", " ");
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("visaType", ctx_r1.inputData.caseType != "I130" ? ctx_r1.inputData.visatype : ctx_r1.inputData.caseType)("stepDetails", ctx_r1.stepDetails)("isViewMode", ctx_r1.inputData["isViewMode"])("isCaseRequest", ctx_r1.inputData["isCaseRequest"]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("configData", i0.ɵɵpureFunction1(6, _c0, ctx_r1.inputData == null ? null : ctx_r1.inputData.layoutCode));
} }
function UscisContentLibraryComponent_p_divider_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-divider", 30);
} }
const _c1 = function (a0, a1) { return { "activeItem": a0, "inActiveItem": a1 }; };
function UscisContentLibraryComponent_a_13_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 31);
    i0.ɵɵlistener("click", function UscisContentLibraryComponent_a_13_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.handleMailingAddressSelection(); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2, "Mailing Address");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(1, _c1, ctx_r3.selectedItem === 0, ctx_r3.selectedItem !== 0));
} }
function UscisContentLibraryComponent_a_14_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 31);
    i0.ɵɵlistener("click", function UscisContentLibraryComponent_a_14_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(); return ctx_r17.handleFeeCalculationSelection(); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2, "Fee Calculation");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(1, _c1, ctx_r4.selectedItem === 1, ctx_r4.selectedItem !== 1));
} }
function UscisContentLibraryComponent_a_15_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 31);
    i0.ɵɵlistener("click", function UscisContentLibraryComponent_a_15_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(); return ctx_r19.handleCardInformationSelection(); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2, "E-Notify / Card Information");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(1, _c1, ctx_r5.selectedItem === 4, ctx_r5.selectedItem !== 4));
} }
function UscisContentLibraryComponent_a_16_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 31);
    i0.ɵɵlistener("click", function UscisContentLibraryComponent_a_16_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(); return ctx_r21.handleConsulateAddressSelection(); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2, "Processing Information ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(1, _c1, ctx_r6.selectedItem === 2, ctx_r6.selectedItem !== 2));
} }
function UscisContentLibraryComponent_a_17_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 31);
    i0.ɵɵlistener("click", function UscisContentLibraryComponent_a_17_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(); return ctx_r23.handlePortOfEntrySelection(); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2, "Port of Entry ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(1, _c1, ctx_r7.selectedItem === 2, ctx_r7.selectedItem !== 2));
} }
function UscisContentLibraryComponent_ng_template_19_Template(rf, ctx) { }
function UscisContentLibraryComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵelement(1, "div", 33);
    i0.ɵɵelementStart(2, "div", 34);
    i0.ɵɵelement(3, "lib-step-status-update-component-library", 35);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("visaType", ctx_r9.inputData.caseType != "I130" ? ctx_r9.inputData.visatype : ctx_r9.inputData.caseType)("stepDetails", ctx_r9.stepDetails)("type", ctx_r9.typeOfButton)("showPreviousStepBtn", ctx_r9.showPrev)("showNextStepBtn", ctx_r9.showNext);
} }
function UscisContentLibraryComponent_div_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵelementStart(1, "span", 37);
    i0.ɵɵelement(2, "i", 38);
    i0.ɵɵtext(3, "This step can be marked complete when you reach the last tab, i.e., Generate Forms ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
class UscisContentLibraryComponent {
    constructor(toastr, store, guard, componentFactoryResolver, stepStatusUpdatePayloadCostruction) {
        this.toastr = toastr;
        this.store = store;
        this.guard = guard;
        this.componentFactoryResolver = componentFactoryResolver;
        this.stepStatusUpdatePayloadCostruction = stepStatusUpdatePayloadCostruction;
        this.showConsulateAddress = true;
        this.showMailingAddress = true;
        this.showFeeCalculation = true;
        // showGenerateForms = true;
        this.showCardInformation = true;
        this.observableSubscription$ = new Subject();
        this.onDialogClose = new EventEmitter();
        this.showNext = false;
        this.showPrev = false;
        this.checkPortEntry = false;
        this.selectedItem = 0;
        this.isLastTab = false;
        this.sectionCode = '';
        this.inputData = this.primaryData;
        // console.log("dialog data ::",this.primaryData)
    }
    ngOnInit() {
        var _a, _b;
        this.isSimplifyH1b = this.simplifyH1b;
        this.store.dispatch(new MarkCleanFormAction({
            dirty: false
        }));
        this.inputData = this.primaryData;
        this.showNext = (_a = this.inputData) === null || _a === void 0 ? void 0 : _a.showNext;
        this.showPrev = (_b = this.inputData) === null || _b === void 0 ? void 0 : _b.showPrev;
        //console.log("this.inputData",this.inputData);
        this.store
            .pipe(select(getStepDetails, { id: this.inputData.stepId }))
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((data) => {
            // console.log('data', data)
            this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 || data.isBeneficiaryAction === 1 ? "MARK_COMPLETE" : "MARK_SUBMIT";
            this.stepDetails = data;
            this.showTabsBasedOnConfig();
            // console.log("this.stepDetails $$$$$$",this.stepDetails);
            if (data.isAttorneyAction === 1 && this.stepDetails.stepStatusDetails.stepStatusCode === 'COMPLETE') {
                // this.handleGenerateFormsSelection();
                switch (this.lastTab) {
                    case 'showMailingAddress':
                        this.handleMailingAddressSelection();
                        break;
                    case 'showFeeCalculation':
                        this.handleFeeCalculationSelection();
                        break;
                    case 'showCardInformation':
                        this.handleCardInformationSelection();
                        break;
                    case 'showConsulateAddress':
                        this.handleConsulateAddressSelection();
                        break;
                    case 'checkPortEntry':
                        this.handlePortOfEntrySelection();
                        break;
                }
                // } else {
                //   if (this.inputData.caseType === 'I129EFILING') {
                //     if (this.stepDetails && this.stepDetails.additionalConfig && JSON.parse(this.stepDetails.additionalConfig).uscisStepConfig) {
                //       let uscisStepConfig = JSON.parse(this.stepDetails.additionalConfig).uscisStepConfig;
                //       if (uscisStepConfig.find(x => x.name === 'Show Generate Forms').value) {
                //         this.handleGenerateFormsSelection();
                //       }
                //     }
                //   } else {
                //     this.handleMailingAddressSelection();
                //   }
                // }
            }
            else {
                this.handleMailingAddressSelection();
            }
            // if (this.stepDetails.stepStatusDetails.stepStatusCode === 'NEW') {
            //   this.updateStepStatus('INPROGRESS');
            // }
        });
    }
    showTabsBasedOnConfig() {
        var _a;
        //  this.stepDetails.additionalConfig = {uscisStepConfig :[{name:'Show Mailing Address',value:true},{name:'Show Consulate Address',value:false},{name:'Show Fee Calculation',value:true, includeDependentsFee:false},{name:'Show Generate Forms',value:true,showDependentForm:true},{name:'Show Port of Entry',value:true}]};
        if (this.stepDetails && this.stepDetails.additionalConfig && JSON.parse(this.stepDetails.additionalConfig).uscisStepConfig) {
            let uscisStepConfig = JSON.parse(this.stepDetails.additionalConfig).uscisStepConfig;
            this.showMailingAddress = (uscisStepConfig.find(x => x.name === 'Show Mailing Address')).value;
            this.showFeeCalculation = (uscisStepConfig.find(x => x.name === 'Show Fee Calculation')).value;
            // this.showGenerateForms = (uscisStepConfig.find(x => x.name === 'Show Generate Forms')).value;
            this.checkPortEntry = (uscisStepConfig.find(x => x.name === 'Show Port of Entry')).value;
            this.showConsulateAddress = (uscisStepConfig.find(x => x.name === 'Show Consulate Address')).value;
            this.showCardInformation = (uscisStepConfig.find(x => x.name === 'Show Card Information')) ? (uscisStepConfig.find(x => x.name === 'Show Card Information')).value : (['APPLN400', 'EB5IMMPETBYREGINV', 'EB5829'].includes(this.inputData.immigrationClassification) || ['I192U', 'UQ', 'K3', 'TD', 'H4'].includes(this.inputData.visatype)) ? true : false;
        }
        else {
            this.checkPortEntry = this.inputData.visatype === 'TN1' ? true : false;
            this.showConsulateAddress = !(this.checkPortEntry || ['TRVLDOCI131', 'REMVCONDTRES', 'WVRUNLAWPRSNCI601A', 'WVRINADMI601', 'DACAI821D', 'EB4IMMJUVNL', 'EB4IMMRELGWRKR', 'EB4IMMOTH'].includes(this.inputData.immigrationClassification) || this.inputData.caseType === 'I130' || this.inputData.getTaskType === 'I485' || ((_a = this.inputData) === null || _a === void 0 ? void 0 : _a.visatype) === 'H4');
        }
        this.findLastTab([
            { name: 'showMailingAddress', value: this.showMailingAddress },
            { name: 'showFeeCalculation', value: this.showFeeCalculation },
            { name: 'showCardInformation', value: this.showCardInformation },
            { name: 'showConsulateAddress', value: this.showConsulateAddress },
            { name: 'checkPortEntry', value: this.checkPortEntry }
        ]);
    }
    findLastTab(booleanArray) {
        const lastTab = booleanArray.slice().reverse().find(item => item.value);
        this.lastTab = lastTab ? lastTab.name : null;
    }
    updateStepStatus(status) {
        this.store.dispatch(updateStepStatus({
            payload: this.stepStatusUpdatePayloadCostruction.payloadConstruction(this.stepDetails, status),
            subTaskId: this.stepDetails.taskId,
            visaType: this.inputData.caseType === 'I130' ?
                this.inputData.caseType : this.inputData.visatype,
            stepId: this.inputData.stepId
        }));
    }
    loadComponent(component) {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
        const viewContainerRef = this.placeHolder.viewContainerRef;
        viewContainerRef.clear();
        const componentRef = viewContainerRef.createComponent(componentFactory);
        componentRef.instance.primaryData = this.inputData;
    }
    handleMailingAddressSelection() {
        this.sectionCode = 'MLCO_ADR';
        this.guard.canDeactivate().pipe(first()).subscribe((response) => {
            if (response) {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
                this.isLastTab = this.lastTab === 'showMailingAddress';
                this.selectedItem = 0;
                this.loadComponent(MailingAddressLibraryComponent);
            }
            else {
                return false;
            }
        });
    }
    handleFeeCalculationSelection() {
        this.sectionCode = 'PBFEE';
        // console.log('lakshmi');
        // console.log(this.inputData);
        this.guard.canDeactivate().pipe(first()).subscribe((response) => {
            if (response) {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
                this.isLastTab = this.lastTab === 'showFeeCalculation';
                this.selectedItem = 1;
                //this.loadComponent(FeeCalculationLibraryComponent);
                if (DEPENDENT_VISAS.includes(this.inputData.visatype) || ((this.showFeeCalculation && this.stepDetails.additionalConfig) && (JSON.parse(this.stepDetails.additionalConfig).uscisStepConfig.find(x => x.name === 'Show Fee Calculation') && JSON.parse(this.stepDetails.additionalConfig).uscisStepConfig.find(x => x.name === 'Show Fee Calculation')).includeDependentsFee)) {
                    this.loadComponent(DependentFeeCalculationLibraryComponent);
                }
                else {
                    this.loadComponent(FeeCalculationLibraryComponent);
                }
            }
            else {
                return false;
            }
        });
    }
    handleConsulateAddressSelection() {
        this.sectionCode = 'MLCO_ADR';
        this.guard.canDeactivate().pipe(first()).subscribe((response) => {
            if (response) {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
                this.isLastTab = this.lastTab === 'showConsulateAddress';
                this.selectedItem = 2;
                this.loadComponent(ConsulateAddressLibraryComponent);
            }
            else {
                return false;
            }
        });
    }
    handlePortOfEntrySelection() {
        this.sectionCode = 'PORT_ENTRY';
        this.guard.canDeactivate().pipe(first()).subscribe((response) => {
            if (response) {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
                this.isLastTab = this.lastTab === 'checkPortEntry';
                this.selectedItem = 2;
                this.loadComponent(PortOfEntryLibraryComponent);
            }
            else {
                return false;
            }
        });
    }
    // handleGenerateFormsSelection() {
    //   if (this.sectionCode === 'GEN_FORMS') {
    //     return;
    //   }
    //   this.sectionCode = 'GEN_FORMS';
    //   this.guard.canDeactivate().pipe(first()).subscribe((response: boolean) => {
    //     if (response) {
    //       this.store.dispatch(new MarkCleanFormAction({
    //         dirty: false
    //       }));
    //       this.isLastTab = true;
    //       this.selectedItem = 3;
    //       this.loadComponent(GenerateFormsLibraryComponent);
    //     }
    //     else {
    //       return false;
    //     }
    //   });
    // }
    handleCardInformationSelection() {
        this.sectionCode = 'CARD_INFO';
        this.guard.canDeactivate().pipe(first()).subscribe((response) => {
            if (response) {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
                this.isLastTab = this.lastTab === 'showCardInformation';
                this.selectedItem = 4;
                this.loadComponent(CardInformationComponent);
            }
            else {
                return false;
            }
        });
    }
    handleClose() {
        this.guard.canDeactivate().pipe(first()).subscribe((response) => {
            if (response) {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
                this.onDialogClose.emit();
            }
            else {
                return false;
            }
        });
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
        // Update the Step Status state to empty state
        this.store.dispatch(updateStepStatusToInitialState());
    }
}
UscisContentLibraryComponent.ɵfac = function UscisContentLibraryComponent_Factory(t) { return new (t || UscisContentLibraryComponent)(i0.ɵɵdirectiveInject(i1.ToastrService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i3.DirtyFormGuard), i0.ɵɵdirectiveInject(i0.ComponentFactoryResolver), i0.ɵɵdirectiveInject(i4.StepStatusUpdatePayloadService)); };
UscisContentLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: UscisContentLibraryComponent, selectors: [["uscis-content-library"]], viewQuery: function UscisContentLibraryComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(PlaceHolderDirective, 3);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.placeHolder = _t.first);
    } }, inputs: { simplifyH1b: "simplifyH1b", primaryData: "primaryData" }, outputs: { onDialogClose: "onDialogClose" }, decls: 22, vars: 17, consts: [[1, "fluid-container"], ["class", "row pt-4 d-flex align-items-center", 4, "ngIf"], ["class", "row pt-1 d-flex align-items-center", 4, "ngIf"], [1, "row"], [1, "col-md-12", "p-0"], [3, "visaType", "stepDetails", "isViewMode", "isCaseRequest", "updateStatus"], ["class", "header-divider", 4, "ngIf"], [1, "main-body", "footer-adjust"], [3, "inputDetails", "primaryData", "sectionCode"], [1, "row", "mt-2"], [1, "card", "card-min", "no-border"], [1, "im-card-tab-menu"], [1, "im-list-group", "leftSidebar"], ["class", "im-list-group-item", 3, "ngClass", "click", 4, "ngIf"], [1, "col-md", "pl-0", "pr-0"], ["dynamicComponentPlaceHolder", ""], ["class", "row pt-3 border-top", 4, "ngIf"], ["class", "row pt-2 border-top", 4, "ngIf"], [1, "row", "pt-4", "d-flex", "align-items-center"], [1, "col-md-8", "step-title", "p-0"], [1, "page-header"], [1, "col-md-4", "editBtn", "headerSubPortion", "px-0"], [1, "col-auto", "px-0", "firstPortion"], ["type", "EDIT", 1, "float-right", 3, "visaType", "stepDetails", "isViewMode", "isCaseRequest"], [1, "col-auto", "pr-0", "pl-2", "secondPortion"], [3, "configData"], [1, "close-icon", "pi", "pi-times", "pull-right", 3, "click"], [1, "row", "pt-1", "d-flex", "align-items-center"], [1, "page-header", "pl-3", "headerPortion"], [1, "m-0"], [1, "header-divider"], [1, "im-list-group-item", 3, "ngClass", "click"], [1, "row", "pt-3", "border-top"], [1, "col-md-6"], [1, "col-md-6", "completeStep"], [1, "d-flex", "col-12", "justify-content-end", 3, "visaType", "stepDetails", "type", "showPreviousStepBtn", "showNextStepBtn"], [1, "row", "pt-2", "border-top"], [2, "color", "#6c6666", "font-size", "14px"], [1, "pi", "pi-info-circle", "pr-2", 2, "color", "#19A0DA"]], template: function UscisContentLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, UscisContentLibraryComponent_div_1_Template, 14, 8, "div", 1);
        i0.ɵɵtemplate(2, UscisContentLibraryComponent_div_2_Template, 14, 8, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵelementStart(5, "lib-assigning-task-library", 5);
        i0.ɵɵlistener("updateStatus", function UscisContentLibraryComponent_Template_lib_assigning_task_library_updateStatus_5_listener($event) { return ctx.updateStepStatus($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, UscisContentLibraryComponent_p_divider_6_Template, 1, 0, "p-divider", 6);
        i0.ɵɵelementStart(7, "div", 7);
        i0.ɵɵelement(8, "lib-last-update-library", 8);
        i0.ɵɵelementStart(9, "div", 9);
        i0.ɵɵelementStart(10, "div", 10);
        i0.ɵɵelementStart(11, "div", 11);
        i0.ɵɵelementStart(12, "div", 12);
        i0.ɵɵtemplate(13, UscisContentLibraryComponent_a_13_Template, 3, 4, "a", 13);
        i0.ɵɵtemplate(14, UscisContentLibraryComponent_a_14_Template, 3, 4, "a", 13);
        i0.ɵɵtemplate(15, UscisContentLibraryComponent_a_15_Template, 3, 4, "a", 13);
        i0.ɵɵtemplate(16, UscisContentLibraryComponent_a_16_Template, 3, 4, "a", 13);
        i0.ɵɵtemplate(17, UscisContentLibraryComponent_a_17_Template, 3, 4, "a", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "div", 14);
        i0.ɵɵtemplate(19, UscisContentLibraryComponent_ng_template_19_Template, 0, 0, "ng-template", 15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(20, UscisContentLibraryComponent_div_20_Template, 4, 5, "div", 16);
        i0.ɵɵtemplate(21, UscisContentLibraryComponent_div_21_Template, 4, 0, "div", 17);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? false : true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? true : false);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("visaType", ctx.inputData.visatype)("stepDetails", ctx.stepDetails)("isViewMode", ctx.primaryData["isViewMode"])("isCaseRequest", ctx.primaryData["isCaseRequest"]);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? false : true);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("inputDetails", ctx.stepDetails)("primaryData", ctx.inputData)("sectionCode", ctx.sectionCode);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.showMailingAddress);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showFeeCalculation);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showCardInformation);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showConsulateAddress);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.checkPortEntry);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.isLastTab);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isLastTab);
    } }, directives: [i5.NgIf, i6.AssigningTaskLibraryComponent, i7.LastUpdateLibraryComponent, i8.PlaceHolderDirective, i9.StepStatusUpdateComponentLibraryComponent, i10.MaximizeDialogLibraryComponent, i11.Divider, i5.NgClass], styles: [".step-title[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-size:14px}.close-icon[_ngcontent-%COMP%]{color:#fff;background-color:#000;padding:8px;border-radius:20px;font-weight:700;cursor:pointer}.activated[_ngcontent-%COMP%]{border:2px solid #007bff}.leftSidebar[_ngcontent-%COMP%]{margin-left:0!important}.leftSidebar[_ngcontent-%COMP%] > a.im-list-group-item[_ngcontent-%COMP%]{background-color:#e1dede!important;margin-right:0!important;padding:10px 0 0!important;width:200px!important;font-size:14px!important;word-break:break-word;white-space:break-spaces}.leftSidebar[_ngcontent-%COMP%] > a.im-list-group-item[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding-bottom:10px!important}.leftSidebar[_ngcontent-%COMP%] > a.im-list-group-item[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:hover{color:#007bff!important;cursor:pointer!important}.activeItem[_ngcontent-%COMP%]{color:#2196f3!important;cursor:pointer!important}.inActiveItem[_ngcontent-%COMP%]{color:#4d4848!important;cursor:pointer!important}div.im-card-tab-menu[_ngcontent-%COMP%]   div.im-list-group[_ngcontent-%COMP%] > a.active[_ngcontent-%COMP%]:after{margin-left:3px!important}.btn-outline-secondary[_ngcontent-%COMP%]{border:1px solid #19a0da!important;background:#fff;height:43px;color:#19a0da;text-transform:uppercase;padding:0 17px!important;font-size:18px!important}.btn-outline-secondary.disabled[_ngcontent-%COMP%], .btn-outline-secondary[_ngcontent-%COMP%]:disabled{opacity:.65!important;border-color:#6c757d!important;color:#6c757d;background-color:transparent}.btn-top-flex[_ngcontent-%COMP%]{vertical-align:text-top}.step-title[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:#3d3d63;font:normal normal 700 21px/32px Source Sans Pro}.step-title[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#626262;font:normal normal normal 13px/22px Source Sans Pro}.main-body[_ngcontent-%COMP%]{height:calc(80vh - 216px);width:100%;overflow:auto}.close-icon-div[_ngcontent-%COMP%]{position:relative!important;right:-15px!important}.main-body[_ngcontent-%COMP%]{padding-right:0!important}.leftSidebar[_ngcontent-%COMP%]{border:none!important}.leftSidebar[_ngcontent-%COMP%] > a.im-list-group-item[_ngcontent-%COMP%]{background-color:#fff!important;font-size:16px!important;padding:15px 10px!important}.im-list-group-item[_ngcontent-%COMP%]{padding:15px 10px 15px 0!important;border-bottom:.5px solid hsla(0,0%,43.9%,.3)!important;font-weight:600!important}.im-list-group-item[_ngcontent-%COMP%]   span[_ngcontent-%COMP%], .leftSidebar[_ngcontent-%COMP%] > a.im-list-group-item[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{border:none!important;padding:0!important;margin:0!important}.card[_ngcontent-%COMP%]{border-right:.5px solid hsla(0,0%,43.9%,.3)!important;padding-right:15px}.itemListActive[_ngcontent-%COMP%]{color:#01a0da!important}.headerPortion[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{color:#002e83;font-weight:600}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UscisContentLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'uscis-content-library',
                templateUrl: 'uscis-content-library.component.html',
                styleUrls: ['uscis-content-library.component.scss']
            }]
    }], function () { return [{ type: i1.ToastrService }, { type: i2.Store }, { type: i3.DirtyFormGuard }, { type: i0.ComponentFactoryResolver }, { type: i4.StepStatusUpdatePayloadService }]; }, { simplifyH1b: [{
            type: Input
        }], placeHolder: [{
            type: ViewChild,
            args: [PlaceHolderDirective, { static: true }]
        }], primaryData: [{
            type: Input
        }], onDialogClose: [{
            type: Output
        }] }); })();

class UscisContentLibraryModule {
}
UscisContentLibraryModule.ɵfac = function UscisContentLibraryModule_Factory(t) { return new (t || UscisContentLibraryModule)(); };
UscisContentLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: UscisContentLibraryModule });
UscisContentLibraryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            StepStatusUpdateComponentLibraryModule,
            PlaceHolderLibraryModule,
            MailingAddressLibraryModule,
            FeeCalculationLibraryModule,
            GenerateFormsLibraryModule,
            ConsulateAddressLibraryModule,
            LastUpdateLibraryModule,
            PortOfEntryLibraryModule,
            AssigningTaskLibraryModule,
            DependentFeeCalculationLibraryModule,
            MaximizeDialogLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(UscisContentLibraryModule, { declarations: [UscisContentLibraryComponent], imports: [PrimengLibraryModule,
        StepStatusUpdateComponentLibraryModule,
        PlaceHolderLibraryModule,
        MailingAddressLibraryModule,
        FeeCalculationLibraryModule,
        GenerateFormsLibraryModule,
        ConsulateAddressLibraryModule,
        LastUpdateLibraryModule,
        PortOfEntryLibraryModule,
        AssigningTaskLibraryModule,
        DependentFeeCalculationLibraryModule,
        MaximizeDialogLibraryModule], exports: [UscisContentLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UscisContentLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [UscisContentLibraryComponent],
                imports: [
                    PrimengLibraryModule,
                    StepStatusUpdateComponentLibraryModule,
                    PlaceHolderLibraryModule,
                    MailingAddressLibraryModule,
                    FeeCalculationLibraryModule,
                    GenerateFormsLibraryModule,
                    ConsulateAddressLibraryModule,
                    LastUpdateLibraryModule,
                    PortOfEntryLibraryModule,
                    AssigningTaskLibraryModule,
                    DependentFeeCalculationLibraryModule,
                    MaximizeDialogLibraryModule
                ],
                exports: [UscisContentLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of uscis-content-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UscisContentLibraryComponent, UscisContentLibraryModule, UscisContentLibraryService };
//# sourceMappingURL=uscis-content-library.js.map
